const initialState = {
    routeId: undefined
}

function route(state = initialState, action) {
    switch (action.type) {

        case 'SET_ROUTE_ID': {
            const { id } = action
            return { ...state, routeId: id }
        }
        case 'ROUTE_ID_CLEARED': {
            return { ...state, routeId: undefined }
        }
        default:
            return state
    }
}

export default route